import { RouteRecordRaw } from 'vue-router'
import { moduleRoutes as usersRoutes } from '@/modules/users'
import { moduleRoutes as dashboardRoutes } from '@/modules/dashboard'
import { moduleRoutes as rolesRoutes } from '@/modules/roles'
import { moduleRoutes as tenantsRoutes } from '@/modules/tenants'
import { moduleRoutes as departmentsRoutes } from '@/modules/departments'
import { moduleRoutes as branchesRoutes } from '@/modules/branches'
import { moduleRoutes as teamsRoutes } from '@/modules/teams'
import { moduleRoutes as contactsRoutes } from '@/modules/contacts'
import { moduleRoutes as accountsRoutes } from '@/modules/accounts'
import { moduleRoutes as spendProjectsRoutes } from '@/modules/spend-projects'
import { moduleRoutes as productsRoutes } from '@/modules/products'
import { moduleRoutes as purchaseOrdersRoutes } from '@/modules/purchase-orders'
import { moduleRoutes as leadsRoutes } from '@/modules/leads'
import { moduleRoutes as calendarRoutes } from '@/modules/calendar'
import { moduleRoutes as catalogsRoutes } from '@/modules/catalogs'
import { moduleRoutes as masterDataRoutes } from '@/modules/master-data'
import { moduleRoutes as auditLogsRoutes } from '@/modules/audit-logs'
import { moduleRoutes as kanbanRoutes } from '@/modules/kanban'
import { moduleRoutes as moduleRegistryRoutes } from '@/modules/module-registry'
import { moduleRoutes as organizationsRoutes } from '@/modules/organizations'
import { moduleRoutes as addressesRoutes } from '@/modules/addresses'
import { moduleRoutes as invoicesRoutes } from '@/modules/invoices'
import { moduleRoutes as gymRoutes } from '@/modules/gym'
import { moduleRoutes as inventoryRoutes } from '@/modules/inventory'
import { moduleRoutes as posRoutes } from '@/modules/pos'
import { errorRoutes } from './ErrorRoutes'

const DashboardLayout = () =>
  import(
    /* webpackChunkName: "dashboard-layout" */ '@/core/layouts/DashboardLayout.vue'
  )

export const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    redirect: { name: 'dashboard' },
    component: DashboardLayout,
    meta: {
      auth: true,
    },
    children: [
      ...dashboardRoutes,
      ...usersRoutes,
      ...rolesRoutes,
      ...tenantsRoutes,
      ...departmentsRoutes,
      ...branchesRoutes,
      ...teamsRoutes,
      ...contactsRoutes,
      ...accountsRoutes,
      ...productsRoutes,
      ...purchaseOrdersRoutes,
      ...spendProjectsRoutes,
      ...leadsRoutes,
      ...calendarRoutes,
      ...catalogsRoutes,
      ...masterDataRoutes,
      ...auditLogsRoutes,
      ...kanbanRoutes,
      ...moduleRegistryRoutes,
      ...organizationsRoutes,
      ...addressesRoutes,
      ...invoicesRoutes,
      ...gymRoutes,
      ...inventoryRoutes,
      ...posRoutes,
      ...errorRoutes,
    ],
  },
]
